import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth-context';
import { AppShell } from './components/dashboard/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { JobsPage } from './pages/JobsPage';
import { JobDetailPage } from './pages/JobDetailPage';
import { KnowledgePage } from './pages/KnowledgePage';
import LoginPage from './pages/LoginPage';
import ProcessPage from './pages/ProcessPage';
import ApiDocsPage from './pages/ApiDocsPage';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import BillingPage from './pages/BillingPage';
import SubusersPage from './pages/SubusersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import EmailInboxPage from './pages/EmailInboxPage';
import EmailBlacklistPage from './pages/EmailBlacklistPage';
import './App.css';

function ProtectedRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/jobs/:jobId" element={<JobDetailPage />} />
        <Route path="/knowledge" element={<KnowledgePage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/api-docs" element={<ApiDocsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/team" element={<SubusersPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/inbox" element={<EmailInboxPage />} />
        <Route path="/email-blacklist" element={<EmailBlacklistPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProtectedRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
